/* src/app/dashboard/dashboard.component.scss */
:host {
  display: block;
  width: 100%;
  min-width: 0;
  color: #17213c;
}
* {
  box-sizing: border-box;
}
.dashboard-page {
  width: 100%;
  min-height: 100%;
  padding: 26px;
  background: #f5f7fb;
  font-family:
    Inter,
    "Segoe UI",
    Arial,
    sans-serif;
}
.dashboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 26px;
}
.dashboard-header h1 {
  margin: 0 0 7px;
  color: #172554;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.5px;
}
.dashboard-header p {
  margin: 0;
  color: #7b8498;
  font-size: 14px;
}
.btn-primary-custom {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 42px;
  padding: 0 17px;
  color: #fff;
  background: #253b80;
  border: 1px solid #253b80;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}
.btn-primary-custom:hover {
  background: #1c2f69;
  transform: translateY(-1px);
}
.btn-primary-custom:focus-visible {
  outline: 3px solid #b9c8ff;
  outline-offset: 2px;
}
.btn-primary-custom i {
  font-size: 15px;
}
.btn-primary-custom.full-width {
  width: 100%;
}
.text-button,
.icon-button {
  color: #4258a5;
  background: transparent;
  border: 0;
  cursor: pointer;
}
.text-button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
}
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
  margin-bottom: 24px;
}
.stat-card {
  min-width: 0;
  padding: 21px;
  background: #fff;
  border: 1px solid #edf0f6;
  border-radius: 13px;
  box-shadow: 0 3px 14px rgba(25, 42, 80, 0.03);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 7px 22px rgba(25, 42, 80, 0.07);
}
.stat-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.stat-icon,
.course-icon,
.activity-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
.stat-icon i,
.course-icon i,
.activity-icon i {
  font-size: 21px;
}
.stat-icon.primary,
.course-icon.primary,
.activity-icon.primary {
  color: #4258a5;
  background: #edf1ff;
}
.stat-icon.success,
.course-icon.success,
.activity-icon.success {
  color: #159765;
  background: #e7f8ef;
}
.stat-icon.warning,
.course-icon.warning,
.activity-icon.warning {
  color: #d99016;
  background: #fff5df;
}
.stat-icon.purple,
.course-icon.purple,
.activity-icon.purple {
  color: #8054c9;
  background: #f2ebff;
}
.stat-icon {
  width: 45px;
  height: 45px;
}
.stat-menu {
  color: #a0a8b9;
  font-size: 18px;
}
.stat-value {
  margin-bottom: 6px;
  color: #182443;
  font-size: 29px;
  font-weight: 750;
  line-height: 1.2;
}
.stat-title {
  color: #707b91;
  font-size: 13px;
}
.stat-change {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 13px;
  color: #159765;
  font-size: 11px;
  font-weight: 500;
}
.dashboard-content {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(300px, 1fr);
  align-items: start;
  gap: 22px;
}
.dashboard-card,
.upload-content {
  min-width: 0;
  padding: 23px;
  background: #fff;
  border: 1px solid #edf0f6;
  border-radius: 13px;
  box-shadow: 0 3px 14px rgba(25, 42, 80, 0.03);
}
.section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 24px;
}
.section-header h2 {
  margin: 0 0 7px;
  color: #1c2948;
  font-size: 16px;
  font-weight: 700;
}
.section-header p {
  margin: 0;
  color: #8a93a6;
  font-size: 12px;
  line-height: 1.5;
}
.icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid #e8ecf5;
  border-radius: 8px;
  font-size: 17px;
}
.icon-button:hover {
  background: #f1f4ff;
}
.course-list,
.document-list {
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.course-list::-webkit-scrollbar,
.document-list::-webkit-scrollbar {
  width: 6px;
}
.course-list::-webkit-scrollbar-track,
.document-list::-webkit-scrollbar-track {
  background: transparent;
}
.course-list::-webkit-scrollbar-thumb,
.document-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.course-list::-webkit-scrollbar-thumb:hover,
.document-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.course-list {
  max-height: 300px;
  padding-right: 8px;
}
.document-list {
  max-height: 300px;
  padding-right: 6px;
}
.course-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 0;
  border-bottom: 1px solid #f0f2f7;
}
.course-item:first-child {
  padding-top: 0;
}
.course-item:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}
.course-icon {
  width: 43px;
  height: 43px;
  margin-top: 2px;
}
.course-details {
  flex: 1;
  min-width: 0;
}
.course-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 13px;
}
.course-heading h3 {
  margin: 0 0 6px;
  color: #263452;
  font-size: 13px;
  font-weight: 650;
  overflow-wrap: anywhere;
}
.course-heading p {
  margin: 0;
  color: #8a93a6;
  font-size: 11px;
}
.progress-label {
  color: #344b91;
  font-size: 12px;
  font-weight: 700;
}
.progress-track {
  height: 7px;
  overflow: hidden;
  background: #edf0f6;
  border-radius: 10px;
}
.progress-bar {
  height: 100%;
  border-radius: inherit;
  transition: width 0.35s ease;
}
.progress-bar.high {
  background: #159765;
}
.progress-bar.medium {
  background: #4258a5;
}
.progress-bar.low {
  background: #d99016;
}
.session-list {
  display: flex;
  flex-direction: column;
}
.session-item {
  display: flex;
  align-items: flex-start;
  gap: 13px;
  padding: 17px 0;
  border-bottom: 1px solid #f0f2f7;
}
.session-item:first-child {
  padding-top: 0;
}
.session-item:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}
.session-date {
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 48px;
  min-height: 54px;
  color: #4258a5;
  background: #edf1ff;
  border-radius: 9px;
}
.session-date span {
  margin-bottom: 3px;
  font-size: 10px;
  font-weight: 700;
}
.session-date strong {
  font-size: 20px;
  line-height: 1;
}
.session-details {
  flex: 1;
  min-width: 0;
}
.session-details h3 {
  margin: 2px 0 8px;
  color: #263452;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.session-details p {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 8px;
  color: #858fa3;
  font-size: 11px;
}
.session-category {
  display: inline-block;
  padding: 4px 8px;
  color: #68758e;
  background: #f3f5fa;
  border-radius: 5px;
  font-size: 10px;
}
.session-action {
  margin-top: 5px;
  color: #7c88a2;
  font-size: 17px;
}
.activity-card {
  grid-column: 1;
}
.activity-list {
  display: flex;
  flex-direction: column;
}
.activity-item {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 15px 0;
  border-bottom: 1px solid #f0f2f7;
}
.activity-item:first-child {
  padding-top: 0;
}
.activity-item:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}
.activity-icon {
  width: 40px;
  height: 40px;
}
.activity-details {
  flex: 1;
  min-width: 0;
}
.activity-details h3 {
  margin: 0 0 5px;
  color: #263452;
  font-size: 12px;
  font-weight: 650;
}
.activity-details p {
  margin: 0;
  color: #8992a5;
  font-size: 11px;
}
.activity-time {
  flex-shrink: 0;
  color: #929bad;
  font-size: 10px;
}
.summary-card {
  display: flex;
  grid-column: 2;
  flex-direction: column;
  align-items: flex-start;
  padding: 25px;
  background:
    linear-gradient(
      145deg,
      #fff 0%,
      #f1f4ff 100%);
}
.summary-card h2 {
  margin: 0 0 10px;
  color: #1c2948;
  font-size: 17px;
  font-weight: 700;
}
.summary-card p {
  margin: 0 0 20px;
  color: #768198;
  font-size: 12px;
  line-height: 1.8;
}
.summary-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 17px;
  color: #fff;
  background: #253b80;
  border-radius: 12px;
}
.summary-icon i {
  font-size: 23px;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 180px;
  padding: 24px;
  color: #7b8498;
  text-align: center;
}
.empty-state i {
  font-size: 32px;
}
.empty-state p {
  margin: 0;
  font-size: 14px;
}
.upload-content .upload-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  color: #253b80;
  background: #eef2ff;
  border-radius: 16px;
}
.upload-content .upload-icon i {
  font-size: 30px;
}
.upload-content h3 {
  margin: 0 0 10px;
  color: #25304a;
  font-size: 17px;
  font-weight: 600;
}
.upload-content p {
  max-width: 300px;
  margin: 0 0 20px;
  color: #7b8498;
  font-size: 13px;
  line-height: 1.6;
}
.upload-content .btn-primary-custom {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  color: #fff;
  background: #253b80;
  border: 0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.upload-content .btn-primary-custom:hover {
  background: #1c2e67;
}
.document-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid #edf0f5;
}
.document-item:last-child {
  border-bottom: 0;
}
.document-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  color: #253b80;
  background: #eef2ff;
  border-radius: 10px;
  font-size: 20px;
}
.document-details {
  flex: 1;
  min-width: 0;
}
.document-details h3 {
  overflow: hidden;
  margin: 0 0 5px;
  color: #25304a;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.document-details p {
  margin: 0;
  color: #7b8498;
  font-size: 12px;
  text-align: left;
}
.document-action {
  color: #98a2b3;
}
@media (max-width: 1200px) {
  .stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-content {
    grid-template-columns: minmax(0, 1fr);
  }
  .activity-card,
  .summary-card {
    grid-column: auto;
  }
}
@media (max-width: 768px) {
  .dashboard-page {
    padding: 18px;
  }
  .dashboard-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .dashboard-header h1 {
    font-size: 23px;
  }
  .stats-grid {
    gap: 12px;
  }
  .stat-card {
    padding: 16px;
  }
  .stat-value {
    font-size: 25px;
  }
  .dashboard-content {
    gap: 16px;
  }
  .dashboard-card {
    padding: 18px;
  }
  .activity-item {
    flex-wrap: wrap;
  }
  .activity-time {
    margin-left: 53px;
  }
}
@media (max-width: 480px) {
  .dashboard-page {
    padding: 13px;
  }
  .stats-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .stat-card {
    padding: 17px;
  }
  .course-item {
    gap: 10px;
  }
  .course-icon {
    width: 36px;
    height: 36px;
  }
  .course-heading {
    gap: 7px;
  }
  .session-item {
    gap: 9px;
  }
  .session-date {
    width: 43px;
  }
  .activity-time {
    font-size: 10px;
  }
}
/*# sourceMappingURL=dashboard.component.css.map */
